export { default as UserMenuProfileInfoMoneyWithTooltip } from './UserMenuProfileInfoMoneyWithTooltip';
